module.exports = __webpack_public_path__ + "static/media/LOGO_MUNICICIPALIDAD_2020_2.ede632cc.svg";